import { Checkbox } from 'antd'
import {
  CheckboxGroup,
  CheckboxWithCount,
  CountBadge,
  FilterSection,
  FilterTitle,
  LabelCell,
} from 'features/inbox/components/filters/filterElements'
import { statusLabelsAsEntries } from 'features/inbox/types/types'
import React, { memo, useCallback, useMemo } from 'react'

export type InspectionStatusFilterProps = {
  selectedStatusFilters: ReadonlyArray<string>
  countsByStatusKey: Readonly<Record<string, number>>
  onChange: (newFilters: ReadonlyArray<string>) => void
}

const InspectionStatusFilterComponent: React.FC<
  InspectionStatusFilterProps
> = ({ selectedStatusFilters, countsByStatusKey, onChange }) => {
  const handleToggle = useCallback(
    (checked: boolean, key: string) => {
      const currentFilters = selectedStatusFilters
      const next = checked
        ? [...currentFilters, key]
        : currentFilters.filter((status) => status !== key)
      onChange(next)
    },
    [onChange, selectedStatusFilters]
  )

  const filteredStatusEntries = useMemo(
    () =>
      statusLabelsAsEntries.filter(
        ([key]) => (countsByStatusKey[key] || 0) > 0
      ),
    [countsByStatusKey]
  )

  return (
    <FilterSection>
      <FilterTitle level={5}>Status</FilterTitle>
      <CheckboxGroup>
        {filteredStatusEntries.map(([key, value]) => (
          <CheckboxWithCount key={key}>
            <LabelCell>
              <Checkbox
                checked={selectedStatusFilters.includes(key)}
                onChange={(e) => handleToggle(e.target.checked, key)}>
                {value}
              </Checkbox>
            </LabelCell>
            <CountBadge>({countsByStatusKey[key] || 0})</CountBadge>
          </CheckboxWithCount>
        ))}
      </CheckboxGroup>
    </FilterSection>
  )
}

export const InspectionStatusFilter = memo(InspectionStatusFilterComponent)
